// extracted by mini-css-extract-plugin
module.exports = {"right-to-c":"styles_right-to-c__lKZ6Z","centered":"styles_centered__ogqWr","left-to-c":"styles_left-to-c__roNjI","left-to-c-xl":"styles_left-to-c-xl__BbfBz"};